import { render } from "./ProgressRecordEditDialog.vue?vue&type=template&id=20d0fe18&ts=true"
import script from "./ProgressRecordEditDialog.vue?vue&type=script&lang=ts"
export * from "./ProgressRecordEditDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__